function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import CustomerCareKeys from '../../../../../locales/keys';
import { BILLER_RULE_INSTANCE_TYPE, DBSS_DECIMAL_PRECISION } from '../../../../../customercare.constants';
import { FREQUENCY_TYPES } from 'invision-core/src/constants/frequency.types.constants';
import CoreLocaleKeys from 'invision-core/src/locales/core.locale.keys';
import i18n from 'invision-core/src/components/i18n/i18n';
var PricingPlanController = /*#__PURE__*/function () {
  function PricingPlanController() {
    _classCallCheck(this, PricingPlanController);
    Object.assign(this, {
      BILLER_RULE_INSTANCE_TYPE: BILLER_RULE_INSTANCE_TYPE,
      CustomerCareKeys: CustomerCareKeys,
      DBSS_DECIMAL_PRECISION: DBSS_DECIMAL_PRECISION,
      getDurationPeriodType: this.getDurationPeriodType.bind(this),
      onMonetaryInputChange: this.onMonetaryInputChange.bind(this),
      onOverrideSelectionChange: this.onOverrideSelectionChange.bind(this),
      onStepperChange: this.onStepperChange.bind(this)
    });
  }
  return _createClass(PricingPlanController, [{
    key: "$onChanges",
    value: function $onChanges(currentObj) {
      if (currentObj.pricingPlan) {
        this.formulateChargeBriHashMap();
      }
    }
  }, {
    key: "formulateChargeBriHashMap",
    value: function formulateChargeBriHashMap() {
      var _this = this;
      this.briChargeHashMap = {};
      var pricingPlanBris = [];
      if (!this.pricingPlan.billerRuleInstances) {
        for (var typeOfInstance in this.pricingPlan.PricingPlanBillerRuleInstances) {
          if (Array.isArray(this.pricingPlan.PricingPlanBillerRuleInstances[typeOfInstance]) && this.pricingPlan.PricingPlanBillerRuleInstances[typeOfInstance].length) {
            pricingPlanBris.push.apply(pricingPlanBris, _toConsumableArray(this.pricingPlan.PricingPlanBillerRuleInstances[typeOfInstance]));
          }
        }
      } else {
        pricingPlanBris.push.apply(pricingPlanBris, _toConsumableArray(this.pricingPlan.billerRuleInstances));
      }
      pricingPlanBris.forEach(function (billerRule) {
        _this.briChargeHashMap[billerRule.Id] = {};
        _this.briChargeHashMap[billerRule.Id]['isOverRideable'] = (billerRule.AllowChargeOverride || billerRule.isOverrideable) && _this.hasPriceOverrideAccess;
        _this.briChargeHashMap[billerRule.Id]['isOverrideSelected'] = billerRule.isOverrideSelected || false;
        _this.briChargeHashMap[billerRule.Id]['billerRuleConfigurationId'] = billerRule.BillerRuleConfigurationId;
        _this.briChargeHashMap[billerRule.Id]['overriddenAmount'] = 0;
        if (_this.shoppingCartItems && _this.shoppingCartItems.length) {
          _this.shoppingCartItems.forEach(function (cartItem) {
            if (cartItem.PricingPlanId === _this.pricingPlan.Id && cartItem.ShoppingCartItemBillerRuleDetails && cartItem.ShoppingCartItemBillerRuleDetails.length) {
              var billerRuleIndex = cartItem.ShoppingCartItemBillerRuleDetails.findIndex(function (shoppingCartBillerRuleDetail) {
                return billerRule.BillerRuleConfigurationId === shoppingCartBillerRuleDetail.BillerRuleConfigurationId;
              });
              if (billerRuleIndex !== -1) {
                _this.briChargeHashMap[billerRule.Id]['isOverrideSelected'] = true;
                _this.briChargeHashMap[billerRule.Id]['overriddenAmount'] = cartItem.ShoppingCartItemBillerRuleDetails[billerRuleIndex].Amount;
              }
            }
            if (cartItem.pricingPlanId === _this.pricingPlan.Id && cartItem.billerRuleDetails && cartItem.billerRuleDetails.length) {
              var _billerRuleIndex = cartItem.billerRuleDetails.findIndex(function (billerRuleDetail) {
                return billerRule.BillerRuleConfigurationId === billerRuleDetail.BillerRuleConfigurationId;
              });
              if (_billerRuleIndex !== -1) {
                _this.briChargeHashMap[billerRule.Id]['isOverrideSelected'] = true;
                _this.briChargeHashMap[billerRule.Id]['overriddenAmount'] = cartItem.billerRuleDetails[_billerRuleIndex].Amount;
              }
            }
          });
        }
      });
    }
  }, {
    key: "onStepperChange",
    value: function onStepperChange(value) {
      var shoppingCartItemBillerRuleDetails = [];
      for (var briHashIndex in this.briChargeHashMap) {
        if (this.briChargeHashMap[briHashIndex].isOverrideSelected) {
          shoppingCartItemBillerRuleDetails.push({
            BillerRuleConfigurationId: this.briChargeHashMap[briHashIndex].billerRuleConfigurationId,
            Amount: this.briChargeHashMap[briHashIndex].overriddenAmount,
            Quantity: 1
          });
        }
      }
      this.onSelection()(value, this.pricingPlan.Id, this.pricingPlan.Name, shoppingCartItemBillerRuleDetails);
    }
  }, {
    key: "getDurationPeriodType",
    value: function getDurationPeriodType(durationPeriodType) {
      switch (durationPeriodType) {
        case FREQUENCY_TYPES.DAILY:
          return i18n.translate(CoreLocaleKeys.PERIOD.DAYS);
        case FREQUENCY_TYPES.HOURLY:
          return i18n.translate(CoreLocaleKeys.PERIOD.HOURS);
        case FREQUENCY_TYPES.MONTHLY:
          return i18n.translate(CoreLocaleKeys.PERIOD.MONTHS);
        case FREQUENCY_TYPES.WEEKLY:
          return i18n.translate(CoreLocaleKeys.PERIOD.WEEKS);
        case FREQUENCY_TYPES.YEARLY:
          return i18n.translate(CoreLocaleKeys.PERIOD.YEARS);
        default:
          return '';
      }
    }
  }, {
    key: "onMonetaryInputChange",
    value: function onMonetaryInputChange() {
      if (this.value) {
        this.onStepperChange(this.value);
      }
    }
  }, {
    key: "onOverrideSelectionChange",
    value: function onOverrideSelectionChange() {
      if (this.value) {
        this.onStepperChange(this.value);
      }
    }
  }]);
}();
export default {
  template: require('./pricing.plan.html'),
  bindings: {
    billerRuleInstances: '<?',
    durationCount: '<?',
    hideMaxQuantity: '<?',
    hasPriceOverrideAccess: '<?',
    lastItem: '<?',
    max: '<?',
    min: '<?',
    onSelection: '&',
    pricingPlan: '<',
    shoppingCartItems: '<?',
    showRenewalPeriodsTooltip: '<?',
    value: '<'
  },
  controller: PricingPlanController
};